<section class="content">
  <app-input-text [formData]="getLastActivityHourInput()" />

  <span class="info">
    {{ 'common.alarm-rule.condition.last-activity.info' | translateSafe }}
  </span>
</section>

@if (this.isOverride()) {
  <section class="override">
    <div class="override-context">
      <span> {{ 'common.messages.alarm-rule.overrided' | translateSafe }} </span>
      <span> {{ 'common.messages.alarm-rule.default-value' | translateSafe }}:
        {{ getDefaultValueString }}
      </span>
    </div>

    <app-button-icon [iconName]="'replay'"
                     [label]="'common.actions.remove-override'"
                     [isTranslated]="true"
                     class="red"
                     (click)="removeOverride()" />
  </section>
}